import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getDocumentContent } from "../utilities/legalDocuments";
import "../styleSheets/terms.css";

function TermsOfService() {
  const { i18n } = useTranslation("common");

  const content = useMemo(
    () => getDocumentContent("termsOfService", i18n.language),
    [i18n.language],
  );

  return (
    <div className="legal-page">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}

export default TermsOfService;
